import { render, staticRenderFns } from "./ReportJobs.vue?vue&type=template&id=6b9c56d0&"
import script from "./ReportJobs.vue?vue&type=script&lang=js&"
export * from "./ReportJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports